// extracted by mini-css-extract-plugin
module.exports =  {"optionTypeSwitcher":"optionTypeSwitcher___GCm4X","optionTypeButton":"optionTypeButton___xP0SE","activeButton":"activeButton___sUMc3","separator":"separator___FwLvZ"};